// defineInputBlocks.ts
import * as Blockly from 'blockly/core';
import { javascriptGenerator } from 'blockly/javascript';


/**
 * Déclare / redéfinit quelques blocs "input" (valeurs) :
 *  - math_number
 *  - text
 *  - text_join
 *  - logic_boolean
 *  - angle_field_block
 *  - color_picker_block
 *
 * Appelle defineInputBlocks() avant d'initialiser le workspace Blockly.
 */
export function defineMathBlocks() {

    /***********************************************
     * 1) math_number (nombre)
     ***********************************************/
    // S'il est déjà défini par Blockly, on peut écraser sa définition ou la laisser telle quelle.
    // Exemple d'une version minimaliste personnalisée :
    Blockly.Blocks['math_number'] = {
        init: function () {
            this.appendDummyInput()
                .appendField(new Blockly.FieldNumber(0), 'NUM');
            this.setOutput(true, 'Number');
            this.setColour(270);
            this.setTooltip('Un nombre');
            this.setHelpUrl('');
        },
    };

    javascriptGenerator.forBlock['math_number'] = function (block, generator) {
        const code = block.getFieldValue('NUM') || '0';
        // Bloc expression => on renvoie [code, ordre]
        return [code, 0];
    };

     /***********************************************
     * 1) Addition Block
     ***********************************************/
     Blockly.Blocks['math_addition'] = {
        init: function () {
            this.appendValueInput('A')
                .setCheck('Number')
                .appendField('Addition');
            this.appendValueInput('B')
                .setCheck('Number')
                .appendField('+');
            this.setOutput(true, 'Number');
            this.setColour(230);
            this.setTooltip('Effectue une addition');
            this.setHelpUrl('');
        },
    };

    javascriptGenerator.forBlock['math_addition'] = function (block) {
        const a = javascriptGenerator.valueToCode(block, 'A', 0) || '0';
        const b = javascriptGenerator.valueToCode(block, 'B', 0) || '0';
        const code = `${a} + ${b}`;
        return [code, 0];
    };

    /***********************************************
     * 2) Subtraction Block
     ***********************************************/
    Blockly.Blocks['math_subtraction'] = {
        init: function () {
            this.appendValueInput('A')
                .setCheck('Number')
                .appendField('Subtraction');
            this.appendValueInput('B')
                .setCheck('Number')
                .appendField('-');
            this.setOutput(true, 'Number');
            this.setColour(230);
            this.setTooltip('Effectue une soustraction');
            this.setHelpUrl('');
        },
    };

    javascriptGenerator.forBlock['math_subtraction'] = function (block) {
        const a = javascriptGenerator.valueToCode(block, 'A', 0) || '0';
        const b = javascriptGenerator.valueToCode(block, 'B', 0) || '0';
        const code = `${a} - ${b}`;
        return [code, 0];
    };

    /***********************************************
     * 3) Multiplication Block
     ***********************************************/
    Blockly.Blocks['math_multiplication'] = {
        init: function () {
            this.appendValueInput('A')
                .setCheck('Number')
                .appendField('Multiplication');
            this.appendValueInput('B')
                .setCheck('Number')
                .appendField('×');
            this.setOutput(true, 'Number');
            this.setColour(230);
            this.setTooltip('Effectue une multiplication');
            this.setHelpUrl('');
        },
    };

    javascriptGenerator.forBlock['math_multiplication'] = function (block) {
        const a = javascriptGenerator.valueToCode(block, 'A', 0) || '0';
        const b = javascriptGenerator.valueToCode(block, 'B', 0) || '0';
        const code = `${a} * ${b}`;
        return [code, 0];
    };

    /***********************************************
     * 4) Division Block
     ***********************************************/
    Blockly.Blocks['math_division'] = {
        init: function () {
            this.appendValueInput('A')
                .setCheck('Number')
                .appendField('Division');
            this.appendValueInput('B')
                .setCheck('Number')
                .appendField('÷');
            this.setOutput(true, 'Number');
            this.setColour(230);
            this.setTooltip('Effectue une division');
            this.setHelpUrl('');
        },
    };

    javascriptGenerator.forBlock['math_division'] = function (block) {
        const a = javascriptGenerator.valueToCode(block, 'A', 0) || '0';
        const b = javascriptGenerator.valueToCode(block, 'B', 0) || '1'; // Avoid division by zero
        const code = `${a} / ${b}`;
        return [code, 0];
    };

    Blockly.Blocks['math_on_list'] = {
        init: function () {
            this.setColour(230);
            this.appendDummyInput()
                .appendField(new Blockly.FieldDropdown([
                    ["somme", "SUM"],
                    ["min", "MIN"],
                    ["max", "MAX"],
                    ["moyenne", "AVERAGE"],
                    ["médiane", "MEDIAN"],
                    ["modes", "MODES"],
                    ["écart-type", "STD_DEV"],
                    ["random item", "RANDOM_ITEM"]
                ]), "OPERATION")
                .appendField("de la liste");
            
            // L'entrée pour la liste (un tableau)
            this.appendValueInput('LIST')
                .setCheck(null)  // ou "Array"
    
            this.setOutput(true, 'Number'); 
            // ou setOutput(true) si "modes" ou "random item" peut renvoyer un tableau ou un nombre
            // Selon vos besoins, vous pouvez mettre "this.setOutput(true, null);"
            
            this.setTooltip("Effectue une opération (somme, min, max, moyenne, médiane...) sur la liste");
            this.setHelpUrl("");
        }
    };

    
    javascriptGenerator.forBlock['math_on_list'] = function (block) {
        const operation = block.getFieldValue('OPERATION'); 
        const listCode = javascriptGenerator.valueToCode(block, 'LIST', 0) || '[]';
    
        // On appelle handleMathOnList(...)
        const code = `handleMathOnList(${listCode}, "${operation}")`;
    
        return [code, 0];
    };  
}
